export default __webpack_public_path__ + "static/media/information--parking--g6.8b6482a2.png";